// extracted by mini-css-extract-plugin
export default {"outputTitle":"DamageDisplay_outputTitle__zktu7","outputText":"DamageDisplay_outputText__oy-St"};